// Content
import module01 from './module-01';
import module02 from './module-02';
import module03 from './module-03';
import module04 from './module-04';
import module05 from './module-05';
import module06 from './module-06';
import module07 from './module-07';
import module08 from './module-08';
import module09 from './module-09';

// Utils
import { defineModule } from '../../utils/define-module';

// Types
import { WorkshopModule, WorkshopModuleDefinition } from '../../types';

/**
 * The `BUDGETING_BASICS` curriculum — its table of contents.
 *
 * Everything that describes a module lives here: its order, its permanent `key`, and
 * its display `name`. The `module-NN.tsx` files hold only its action items, so a
 * module's subject can be replaced by editing one entry here plus that file's
 * components — without renaming a file, an export, or an import.
 *
 * Array order is the order modules are worked through, and drives the Next button's
 * progression. Keep it in filename order; to resequence the curriculum, renumber the
 * files rather than shuffling this list, or the numbering stops telling the truth.
 */
const CURRICULUM: WorkshopModuleDefinition[] = [
  {
    key: 'welcome',
    name: 'Welcome to Budgeting Basics',
    actionItems: module01
  },
  {
    key: 'income',
    name: 'List Your Income',
    actionItems: module02
  },
  {
    key: 'four-walls',
    name: 'List Your Four Walls',
    actionItems: module03
  },
  {
    key: 'expenses',
    name: 'List Your Expenses',
    actionItems: module04
  },
  {
    key: 'debt',
    name: 'List Your Debt',
    actionItems: module05
  },
  {
    key: 'transactions',
    name: 'Tracking Transactions',
    actionItems: module06
  },
  {
    key: 'everydollar',
    name: 'EveryDollar Walkthrough',
    actionItems: module07
  },
  {
    key: 'budget-meeting',
    name: 'Monthly Budget Meeting',
    actionItems: module08
  },
  {
    key: 'next-move',
    name: 'Your Next Move',
    actionItems: module09
  }
];

export const BUDGETING_BASICS_MODULES: WorkshopModule[] =
  CURRICULUM.map(defineModule);
